<template>
  <div class="app flex-row align-items-center bg-img" :style="{'background-image': randomImage}" @keyup.enter="validateAndSignIn">
    <div class="login-block-logo">
      <!--<img src="" style="width: 240px;" />-->
    </div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-5">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <h1 class="text-center">{{$lang.Login.TitleForm}}</h1>
                <p class="text-muted">{{$lang.Login.TitleFormDescription}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="fas fa-user"></i></span>
                  <b-form-input type="text"
                          id="username"
                          name="username"
                          :placeholder="errors.has('username') ? errors.first('username') : $lang.Login.Username"
                          v-model="credentials.username"
                          v-validate="'required'"
                          aria-describedby="usernameErrorFeedback"
                          :state="errors.has('username') ? false : getValidationState('username')"
                          @blur.native="getValidationState('username')">
                  </b-form-input>
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="fas fa-lock"></i></span>
                  <b-form-input type="password"
                          id="password"
                          name="password"
                          :placeholder="errors.has('password') ? errors.first('password') : $lang.Login.Password"
                          v-model="credentials.password"
                          data-vv-as="senha"
                          v-validate="'required'"
                          aria-describedby="passwordErrorFeedback"
                          :state="errors.has('password') ? false : getValidationState('password')"
                          @blur.native="getValidationState('password')">
                  </b-form-input>
                </div>
                <div class="row">
                  <div class="col-6 text-left">
                    <!-- <router-link :to="{ name: 'LostPassword' }" class="btn btn-link px-0">{{$lang.Login.LostPassowrd}}</router-link> -->
                  </div>
                  <div class="col-6 text-right">
                    <button type="button" class="btn btn-third px-4" @click="validateAndSignIn"><i class="fas fa-sign-in-alt"></i> {{$lang.Login.ButtonEnter}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center pt-3 login-version">
        <label style="color: #fff;">ZOPONE T.I. &nbsp;-&nbsp; {{$lang.Login.LabelVersion}} {{version}}</label>
      </div>

    </div>
  </div>
</template>

<script>
import Authentication from './Authentication.js'
export default Authentication
</script>

<style scoped>
  .card {
    opacity: 0.96;
    box-shadow: 0.25rem 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
  }
</style>



// WEBPACK FOOTER //
// src/views/public/auth/Authentication.vue